export const cls = (...classes) => {
    return classes
        .filter(it => !!it)
        .map(it => (Array.isArray(it) ? it.join(' ') : it))
        .join(' ');
};
//# sourceMappingURL=cls.js.map